module.exports = __webpack_public_path__ + "img/5.7b2c3383.png";